<template>
  <div class="help-collapse" :class="{'collapsed': visible}">
    <b-button
      :aria-expanded="visible ? 'true' : 'false'"
      class="help-collapse-button w-100 d-flex justify-content-between align-items-center"
      aria-controls="collapse-4"
      @click="visible = !visible"
    >
      <div>
        <span class="text-color-primary">
          <i class="ri-question-line"></i>
        </span>
        Ayuda
      </div>

      <i class="ri-arrow-down-s-line"></i>
    </b-button>

    <b-collapse id="collapse-4" v-model="visible">
      <slot name="content"></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true
    };
  }
};
</script>

<style lang="stylus" scoped>
@import "../../Styles/components/help-collapse.styl"
</style>
